import {
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Typography,
} from '@mui/material';
import { styled } from '@mui/material/styles';
import { generatePath, Link } from 'react-router-dom';
import { RELEVANCE_TEST_DEFINITION_DETAILS } from 'src/lib/routes';
import { CardRow } from '../common/CardTable/CardRow';
import { CardCell } from '../common/CardTable/CardCell';
import { EmptyState } from '../common/EmptyState';
import { COLUMN_HEADERS, COLUMN_WIDTHS } from './columnConfig';

const StyledTableContainer = styled(TableContainer)(() => ({
    height: '100%',
    overflowX: 'visible',
}));

interface RelevanceTestDefinitionSearchResultsProps {
    searchTerm: string;
    results: Models.IngestConfigApi.RelevanceTests.RelevanceTestDefinition[];
}

export const RelevanceTestDefinitionSearchResults = ({
    searchTerm,
    results,
}: RelevanceTestDefinitionSearchResultsProps): JSX.Element => {
    if (results.length === 0) {
        return (
            <EmptyState>
                <Typography gutterBottom align="center" variant="h6">
                    No Results Found
                </Typography>
                <Typography align="center" variant="body1">
                    {searchTerm
                        ? 'Try adjusting your search criteria'
                        : 'Enter a search term to get started'}
                </Typography>
            </EmptyState>
        );
    }

    return (
        <StyledTableContainer>
            <Table stickyHeader>
                <TableHead>
                    <TableRow>
                        <TableCell align="center" width={COLUMN_WIDTHS.searchTerm}>{COLUMN_HEADERS.searchTerm}</TableCell>
                        <TableCell align="center" width={COLUMN_WIDTHS.gallery}>{COLUMN_HEADERS.gallery}</TableCell>
                        <TableCell align="center" width={COLUMN_WIDTHS.culture}>{COLUMN_HEADERS.culture}</TableCell>
                        <TableCell align="center" width={COLUMN_WIDTHS.sampleSize}>{COLUMN_HEADERS.sampleSize}</TableCell>
                        <TableCell align="center" width={COLUMN_WIDTHS.scoredEntities}>{COLUMN_HEADERS.scoredEntities}</TableCell>
                        <TableCell align="center" width={COLUMN_WIDTHS.createdBy}>{COLUMN_HEADERS.createdBy}</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {results.map((row) => (
                        <CardRow
                            hover
                            component={Link}
                            key={row.testDefinitionId}
                            to={generatePath(RELEVANCE_TEST_DEFINITION_DETAILS, {
                                testDefinitionId: row.testDefinitionId,
                            })}
                        >
                            <CardCell align="center" width={COLUMN_WIDTHS.searchTerm}>{row.keywordSearchTerm}</CardCell>
                            <CardCell align="center" width={COLUMN_WIDTHS.gallery}>{row.productName}</CardCell>
                            <CardCell align="center" width={COLUMN_WIDTHS.culture}>{row.culture}</CardCell>
                            <CardCell align="center" width={COLUMN_WIDTHS.sampleSize}>{row.kSampleSize}</CardCell>
                            <CardCell align="center" width={COLUMN_WIDTHS.scoredEntities}>{row.scoredEntities.length}</CardCell>
                            <CardCell align="center" width={COLUMN_WIDTHS.createdBy}>{row.createdBy?.split('@')[0]}</CardCell>
                        </CardRow>
                    ))}
                </TableBody>
            </Table>
        </StyledTableContainer>
    );
};
